import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {ToastrService} from 'ngx-toastr';
import {environment} from '@environments/environment';
import {AuthService} from '@services/auth.service';
import jwtDecode from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private toastr: ToastrService) {
  }

  canActivate_NEW(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {

    if (AuthService.User)
      return true;

    this.router.navigate(['/login'],
      { queryParams: { returnUrl: state.url } });

    return false;
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    if (!AuthService.User)
      this.router.navigate(['/login'],
        { queryParams: { returnUrl: state.url } });

    if (AuthService.User) {
      const token = AuthService.User.accessToken;
      const decodedToken = jwtDecode(token);
      const roles: string | string[] = decodedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];

      if (!roles) {
        this.toastr.error('You do not have any roles for this application', 'Please contact support');
        return false;
      }

      for (const role of environment.allowed_engineer_roles) {
        if (Array.isArray(roles)) {
          if (roles.includes(role)) {
            return true;
          }
        }

        if (role == roles) {
          return true;
        }
      }

      this.toastr.error('You have the incorrect role to access this application', 'Please contact support');
    }
    return false;
  }
}

